import { alpha } from "@material-ui/core/styles";
import sidebarScrollbar from "../helpers/sidebarScrollbar";

// Estilos das páginas de listagem (cabeçalho com contagem + card com busca,
// tabela e rodapé). Mesmo visual da página de Contatos.
// Uso: makeStyles((theme) => ({ ...listPageStyles(theme), ...extras }))
const listPageStyles = (theme) => ({
  header: {
    // o CssBaseline do app fica fora do ThemeProvider: sem isso o texto
    // herda o preto do tema claro no tema escuro
    color: theme.palette.text.primary,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(0, 0.75, 2),
  },
  headerTitle: {
    "& h5": { marginBottom: 0, fontWeight: 600 },
  },
  headerButtons: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      "& > *": { flex: "1 1 auto" },
    },
  },
  headerButton: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    height: 40,
    padding: theme.spacing(0, 2),
  },
  secondaryButton: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
  },
  mainPaper: {
    color: theme.palette.text.primary,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 14,
    width: "100%",
    boxSizing: "border-box",
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  searchField: {
    flex: "1 1 280px",
    maxWidth: 420,
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.background.paper,
    },
    [theme.breakpoints.down("xs")]: { maxWidth: "100%" },
  },
  tableWrapper: {
    flex: 1,
    overflowY: "auto",
    overflowX: "auto",
    ...sidebarScrollbar(theme),
  },
  headCell: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    backgroundColor: theme.palette.background.paper,
    whiteSpace: "nowrap",
  },
  row: {
    "& > td": {
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
    },
    transition: "background-color .12s",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 2,
  },
  iconAction: {
    color: theme.palette.text.secondary,
    "&:hover": { color: theme.palette.text.primary },
  },
  deleteAction: {
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.08),
    },
  },
  footer: {
    padding: theme.spacing(1.5, 2.5),
    borderTop: `1px solid ${theme.palette.divider}`,
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  muted: {
    color: theme.palette.text.secondary,
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(6, 2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  emptyIcon: {
    fontSize: 48,
    opacity: 0.4,
  },
});

export default listPageStyles;
